export type Seller = {
    address: string;
    address2: string;
    agentName: string;
    alias: string;
    betas: number[];
    city: string;
    country: string;
    countryCode: string;
    globalATGId: string;
    listingAgentId: number;
    logoId: string;
    name: string;
    regionCode: string;
    sellerId: number;
    stateCode: string;
    stateName: string;
    zip: string;
};

export const emptySeller: Seller = {
    address: '',
    address2: '',
    agentName: '',
    alias: '',
    betas: [],
    city: '',
    country: '',
    countryCode: '',
    globalATGId: '',
    listingAgentId: 0,
    logoId: '',
    name: '',
    regionCode: '',
    sellerId: 0,
    stateCode: '',
    stateName: '',
    zip: '',
};
